// Site content. Edit this file to change copy, links and the APPS list.

export const SITE = {
  name: 'UXS',
  domain: 'uxs.ma',
  tagline: ['We design digital products', 'From pen to pixels'],
  links: {
    start: 'https://calendly.com/zouhair-majzoub/30min',
    portfolio: 'https://contra.com/zouhairmaj',
    linkedin: 'https://www.linkedin.com/in/zouhair-majzoub/',
    x: 'https://x.com/ZouhairMaj'
  },
  copyright: 'Copyright © 1984 UXS. All Rights Reserved'
};

// Each entry becomes a "cartridge" card in the APPS section.
// sprite: key from src/scene/sprites.js
// status: 'live' | 'soon'
export const APPS = [
  {
    id: 'datao',
    number: '01',
    name: 'DATAO',
    url: 'https://datao.ma',
    host: 'datao.ma',
    tagline: 'Accélérez votre veille des marchés publics au Maroc.',
    description:
      'An AI platform that reads hundreds of Moroccan public tenders, extracts the key data, writes executive summaries and sends the right opportunities to the right team.',
    tags: ['AI', 'SAAS', 'B2B'],
    sprite: 'doc',
    status: 'live',
    cta: 'LAUNCH'
  },
  {
    id: 'dotname',
    number: '02',
    name: 'DOTNAME',
    url: 'https://dotname.app',
    host: 'dotname.app',
    tagline: "Find a domain that isn't taken. In seconds, not weeks.",
    description:
      'Describe your business in plain English. An AI naming engine suggests brandable names and checks availability live across 500+ extensions. Free, no sign-up.',
    tags: ['AI', 'FREE', 'TOOL'],
    sprite: 'globe',
    status: 'live',
    cta: 'LAUNCH'
  },
  {
    id: 'next',
    number: '03',
    name: '???',
    url: 'https://calendly.com/zouhair-majzoub/30min',
    host: '',
    tagline: 'Next cartridge loading...',
    description:
      'Have a product idea? We design it, build it and ship it. From pen to pixels.',
    tags: ['YOUR APP'],
    sprite: 'question',
    status: 'soon',
    cta: 'INSERT COIN'
  }
];

// Desktop icons shown after the apps (classic desktop style, label under the icon).
export const DESKTOP = [
  { id: 'portfolio', label: 'Portfolio', sprite: 'folder', url: SITE.links.portfolio },
  { id: 'start', label: 'Book a meeting', sprite: 'calendar', url: SITE.links.start },
  { id: 'linkedin', label: 'LinkedIn', sprite: 'linkedin', url: SITE.links.linkedin },
  { id: 'x', label: 'X', sprite: 'x', url: SITE.links.x }
];
